import React, {useState} from "react";
import { Button, ButtonGroup, Container } from "react-bootstrap";
import { FaUserPlus, FaUserMinus, FaChartBar, FaCog } from "react-icons/fa";
import PatientLookUpAutocompleteModal from "../molecules/PatientLookUpAutocompleteModal";
import DeviceFormModal from "../molecules/DeviceFormModal";
import { removeSession } from "../molecules/api";

interface ControlPanelProps {
  hasPatient: boolean; // Determines button states
  deviceId: string; // Id needed for both deivce edit and patient lookup
  onAddPatient: () => void;
  onRemovePatient: () => void;
  onPauseSession: () => void;
  onViewStatistics: () => void;
  onEditDevice: () => void;
  sessionId?:string;
  patientId?: string;
  device?: {
    id: string;
    locationId: string;
    locationCode: string;
    locationColor: "blue" | "red" | "green" | "yellow" | "purple";
  }
}

const ControlPanel: React.FC<ControlPanelProps> = ({
  hasPatient,
  onAddPatient,
  onRemovePatient,
  onViewStatistics,
  deviceId,
  sessionId,
  patientId,
  device
}) => {
  const [showPatientAutocomplete, setShowPatientAutocomplete] = useState(false);
  const [showDeviceForm, setShowDeviceForm] = useState(false);
  return (
    <Container className="text-center mt-4">
      <ButtonGroup vertical>
        <Button 
          variant="success" 
          onClick={() => {
            setShowPatientAutocomplete(true);
          }} 
          className="mb-2" 
          disabled={hasPatient} // Disabled if patient exists
        >
          <FaUserPlus className="me-2" /> Add Patient
        </Button>
        <Button 
          variant="danger" 
          onClick={() => {
            if(deviceId && sessionId && patientId) {
              removeSession(sessionId, deviceId, patientId).then(() => {
              onRemovePatient()
              })
            }
          }}
          className="mb-2" 
          disabled={!hasPatient} // Disabled if no patient
        >
          <FaUserMinus className="me-2" /> Remove Patient
        </Button>
        <Button 
          variant="info" 
          onClick={onViewStatistics} 
          className="mb-2" 
          disabled={!hasPatient} // Disabled if no patient
        >
          <FaChartBar className="me-2" /> View Session Statistics
        </Button>
        <Button variant="secondary" onClick={() => setShowDeviceForm(true)}>
          <FaCog className="me-2" /> Edit Device Properties
        </Button>
      </ButtonGroup>
      <PatientLookUpAutocompleteModal show={showPatientAutocomplete} onHide={() => {
        setShowPatientAutocomplete(false)
        onAddPatient();
      }} deviceId={deviceId} />
      <DeviceFormModal show={showDeviceForm} onHide={() => setShowDeviceForm(false)} device={{
        id: deviceId,
        locationId: device?.locationId || "",
        locationCode: device?.locationCode || "",
        locationColor: device?.locationColor || "blue",
      }} />
    </Container>
  );
};

export default ControlPanel;